<div class="leasingModal">
    <h1>{{ title }}</h1>
    <div mat-dialog-content class="carSpecSummaryModal">
        <p class="feedbackMessage">
            {{ message }}
        </p>
		 <div id="baanaBanner" class="lightGreen row" *ngIf="level == 'success'">
	         <div id="baanaContentContainer" class="column right">
	             <img mat-card-sm-image
	                  src="https://autotallifeed.s3.eu-west-1.amazonaws.com/autotalli/private-leasing/assets/img/logo_baana.png">
	             <p class="textContent">Voit myös kilpailuttaa tarjoukset autoliikkeiltä ympäri
	                 Suomen ja myydä
	                 eniten tarjoavalle, vaivattomasti jopa 48 tunnissa.</p>
	         </div>
	         <div id="baanaButtonContainer" class="column left">
	             <a id="baanaButton" type="button" mat-raised-button
	                class="button bordered green targetButton"
	                target="_blank"
	                href="https://baana.nettiauto.com/?utm_source=autotalli.com&utm_medium=almainternal&utm_campaign=kiintea_baana_yksityisleasing&utm_content=kiintea_baana">
	                 <span>SIIRRY BAANAAN <span
	                         class="material-icons baanaArow">keyboard_arrow_right</span></span>
	             </a>
	         </div>
	     </div>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button class="orange button" (click)="close()" cdkFocusInitial>SULJE</button>
    </div>
</div>